// src/WaterBodiesInfo.js

import React, { useState } from 'react';
import './WaterBodiesInfo.css';

const waterBodiesData = {
    "USA": {
      oceans: ["Atlantic Ocean", "Pacific Ocean"],
      seas: ["Gulf of Mexico", "Bering Sea"],
      rivers: [
        { name: "Mississippi River", length: "3,730 km" },
        { name: "Missouri River", length: "3,767 km" }
      ],
      ponds: ["Walden Pond", "Lake Placid"],
      waterfalls: ["Niagara Falls", "Yosemite Falls"],
      otherSpecialities: [
        "Great Lakes - largest group of freshwater lakes",
        "Colorado River - Grand Canyon",
        "Florida Everglades - vast wetland"
      ]
    },
    "India": {
      oceans: ["Indian Ocean"],
      seas: ["Arabian Sea", "Bay of Bengal"],
      rivers: [
        { name: "Ganges", length: "2,525 km" },
        { name: "Brahmaputra", length: "2,900 km" }
      ],
      ponds: ["Dal Lake", "Chilika Lake"],
      waterfalls: ["Jog Falls", "Dudhsagar Falls"],
      otherSpecialities: [
        "Backwaters of Kerala - network of interconnected canals and lakes",
        "Sundarbans - largest mangrove forest",
        "Rann of Kutch - largest salt desert"
      ]
    },
    "Canada": {
      oceans: ["Atlantic Ocean", "Pacific Ocean", "Arctic Ocean"],
      seas: ["Beaufort Sea", "Labrador Sea"],
      rivers: [
        { name: "Mackenzie River", length: "4,241 km" },
        { name: "St. Lawrence River", length: "3,058 km" }
      ],
      ponds: ["Emerald Lake", "Moraine Lake"],
      waterfalls: ["Niagara Falls", "Montmorency Falls"],
      otherSpecialities: [
        "Great Lakes - shared with USA",
        "Hudson Bay - large inland sea",
        "Canadian Shield - ancient geological core"
      ]
    },
    "Australia": {
      oceans: ["Indian Ocean", "Pacific Ocean"],
      seas: ["Coral Sea", "Tasman Sea"],
      rivers: [
        { name: "Murray River", length: "2,508 km" },
        { name: "Darling River", length: "1,472 km" }
      ],
      ponds: ["Lake Eyre", "Lake Hillier"],
      waterfalls: ["Jim Jim Falls", "Wallaman Falls"],
      otherSpecialities: [
        "Great Barrier Reef - largest coral reef system",
        "Lake Eyre - largest lake when filled",
        "Tasman Sea - separates Australia and New Zealand"
      ]
    },
    "Brazil": {
      oceans: ["Atlantic Ocean"],
      seas: ["None"],
      rivers: [
        { name: "Amazon River", length: "7,062 km" },
        { name: "Paraná River", length: "4,880 km" }
      ],
      ponds: ["Lagoa dos Patos", "Lagoa Mirim"],
      waterfalls: ["Iguazu Falls", "Caracol Falls"],
      otherSpecialities: [
        "Amazon Rainforest - largest tropical rainforest",
        "Pantanal - largest tropical wetland",
        "Rio de la Plata - estuary shared with Argentina"
      ]
    },
    "China": {
      oceans: ["Pacific Ocean"],
      seas: ["South China Sea", "East China Sea"],
      rivers: [
        { name: "Yangtze River", length: "6,300 km" },
        { name: "Yellow River", length: "5,464 km" }
      ],
      ponds: ["West Lake", "Qinghai Lake"],
      waterfalls: ["Huangguoshu Waterfall", "Detian Falls"],
      otherSpecialities: [
        "Three Gorges Dam - largest hydroelectric dam",
        "Qinghai-Tibet Plateau - highest plateau",
        "South China Sea - disputed maritime area"
      ]
    },
    "Japan": {
      oceans: ["Pacific Ocean"],
      seas: ["Sea of Japan", "East China Sea"],
      rivers: [
        { name: "Shinano River", length: "367 km" },
        { name: "Tone River", length: "322 km" }
      ],
      ponds: ["Lake Biwa", "Lake Kawaguchi"],
      waterfalls: ["Kegon Falls", "Nachi Falls"],
      otherSpecialities: [
        "Seto Inland Sea - major body of water",
        "Japanese Archipelago - chain of islands",
        "Hot springs - onsen culture"
      ]
    },
    "United Kingdom": {
      oceans: ["Atlantic Ocean"],
      seas: ["North Sea", "Irish Sea"],
      rivers: [
        { name: "River Severn", length: "354 km" },
        { name: "River Thames", length: "346 km" }
      ],
      ponds: ["Lake District", "Loch Ness"],
      waterfalls: ["High Force", "Ingleton Waterfalls"],
      otherSpecialities: [
        "English Channel - separates UK and France",
        "Loch Ness - famous for mythical creature",
        "Lake District - scenic national park"
      ]
    },
    "Russia": {
      oceans: ["Arctic Ocean", "Pacific Ocean"],
      seas: ["Baltic Sea", "Black Sea"],
      rivers: [
        { name: "Volga River", length: "3,531 km" },
        { name: "Lena River", length: "4,400 km" }
      ],
      ponds: ["Lake Baikal", "Caspian Sea"],
      waterfalls: ["Kivach Falls", "Talnikovy Waterfall"],
      otherSpecialities: [
        "Lake Baikal - deepest freshwater lake",
        "Volga River - longest river in Europe",
        "Caspian Sea - largest enclosed inland body of water"
      ]
    },
    "Mexico": {
      oceans: ["Pacific Ocean", "Atlantic Ocean"],
      seas: ["Gulf of Mexico", "Caribbean Sea"],
      rivers: [
        { name: "Rio Grande", length: "3,057 km" },
        { name: "Usumacinta River", length: "1,000 km" }
      ],
      ponds: ["Lake Chapala", "Laguna de Bacalar"],
      waterfalls: ["Agua Azul", "Hierve el Agua"],
      otherSpecialities: [
        "Sea of Cortez - diverse marine life",
        "Cenotes - natural sinkholes",
        "Xel-Há - natural water park"
      ]
    },
    "Italy": {
      oceans: ["None"],
      seas: ["Mediterranean Sea", "Adriatic Sea"],
      rivers: [
        { name: "Po River", length: "652 km" },
        { name: "Tiber River", length: "406 km" }
      ],
      ponds: ["Lake Como", "Lake Garda"],
      waterfalls: ["Cascata delle Marmore", "Cascata del Toce"],
      otherSpecialities: [
        "Amalfi Coast - scenic coastal area",
        "Venetian Lagoon - lagoon around Venice",
        "Tuscan Lakes - picturesque lakes"
      ]
    },
    "France": {
      oceans: ["Atlantic Ocean"],
      seas: ["Mediterranean Sea", "North Sea"],
      rivers: [
        { name: "Loire River", length: "1,012 km" },
        { name: "Seine River", length: "776 km" }
      ],
      ponds: ["Étang de Thau", "Lac du Bourget"],
      waterfalls: ["Gavarnie Falls", "Sillans-la-Cascade"],
      otherSpecialities: [
        "French Riviera - famous coastline",
        "Mont Saint-Michel - tidal island",
        "Camargue - delta region"
      ]
    },
    "Germany": {
      oceans: ["None"],
      seas: ["North Sea", "Baltic Sea"],
      rivers: [
        { name: "Rhine River", length: "1,230 km" },
        { name: "Elbe River", length: "1,094 km" }
      ],
      ponds: ["Chiemsee", "Lake Constance"],
      waterfalls: ["Triberg Waterfalls", "Kuhflucht Waterfalls"],
      otherSpecialities: [
        "Black Forest - scenic region",
        "North Frisian Islands - island group",
        "Bavarian Lakes - beautiful lakes"
      ]
    },
    "South Africa": {
      oceans: ["Atlantic Ocean", "Indian Ocean"],
      seas: ["None"],
      rivers: [
        { name: "Orange River", length: "2,200 km" },
        { name: "Limpopo River", length: "1,750 km" }
      ],
      ponds: ["Blyde River Canyon", "Knysna Lagoon"],
      waterfalls: ["Tugela Falls", "Lisbon Falls"],
      otherSpecialities: [
        "Cape of Good Hope - iconic headland",
        "St. Lucia Estuary - biodiversity hotspot",
        "Garden Route - coastal scenic route"
      ]
    },
   
  // Add more countries as needed
};

const WaterBodiesInfo = () => {
  const [selectedCountry, setSelectedCountry] = useState('USA');
  const [readAloud, setReadAloud] = useState(false);

  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
  };

  const handleReadAloud = () => {
    const country = waterBodiesData[selectedCountry];
    const utterance = new SpeechSynthesisUtterance(
      `In ${selectedCountry}, the important oceans are ${country.oceans.join(", ")}. The seas are ${country.seas.join(", ")}. Major rivers include ${country.rivers.map(river => `${river.name} with a length of ${river.length}`).join(", ")}. Notable ponds are ${country.ponds.join(", ")}. Waterfalls include ${country.waterfalls.join(", ")}. Other water-related specialties are ${country.otherSpecialities.join(", ")}.`
    );
    speechSynthesis.speak(utterance);
    setReadAloud(true);
  };

  const country = waterBodiesData[selectedCountry];

  return (
    <div className="water-bodies-info">
      <h1>Oceans, Seas, Rivers, Ponds and waterfalls</h1>
      <div>
        <label>
          Select Country:
          <select value={selectedCountry} onChange={handleCountryChange}>
            {Object.keys(waterBodiesData).map((country) => (
              <option key={country} value={country}>{country}</option>
            ))}
          </select>
        </label>
      </div>
      <div className="info">
        <h2>{selectedCountry}</h2>
        <p><strong>Oceans:</strong> {country.oceans.join(", ")}</p>
        <p><strong>Seas:</strong> {country.seas.join(", ")}</p>
        <p><strong>Rivers:</strong></p>
        <ul>
          {country.rivers.map((river, index) => (
            <li key={index}>{river.name} - {river.length}</li>
          ))}
        </ul>
        <p><strong>Ponds:</strong> {country.ponds.join(", ")}</p>
        <p><strong>Waterfalls:</strong> {country.waterfalls.join(", ")}</p>
        <p><strong>Other Specialities:</strong></p>
        <ul>
          {country.otherSpecialities.map((speciality, index) => (
            <li key={index}>{speciality}</li>
          ))}
        </ul>
      </div>
      <button onClick={handleReadAloud}>Read Aloud</button>
    </div>
  );
};

export default WaterBodiesInfo;
